import { render } from "./TDBG_SRLQ.vue?vue&type=template&id=12ea1ff6&scoped=true"
import script from "./TDBG_SRLQ.vue?vue&type=script&lang=js"
export * from "./TDBG_SRLQ.vue?vue&type=script&lang=js"

import "./TDBG_SRLQ.vue?vue&type=style&index=0&id=12ea1ff6&scoped=scoped&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ea1ff6"]])

export default __exports__